import {fetchAllDicList} from '@/api/common'

const app = {

	state: {
		dicList: [],
	},
	getters: {},
	mutations: {
		SET_DICLIST: (state, lists) => {
			state.dicList = lists;
		},
	},

	actions: {
		getDicListAcions({commit}) {
			return new Promise((resolve, reject) => {
				fetchAllDicList().then(response => {
					const data = response.data;
					if (data.status === 200) {
						commit('SET_DICLIST', data.items);
					}
					resolve(response)
				}).catch(error => {
					reject(error)
				})
			})
		},
	}
}
export default app



// WEBPACK FOOTER //
// ./src/store/dics.js